import React from 'react'
import {
  TextInput,
  SimpleForm,
  required,
  Create,
  useNotify,
  useRedirect,
  SelectInput,
  ImageInput,
  ImageField,
  FormDataConsumer,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'

import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    setFormData,
    closeDrawer,
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Inserir Nova Pessoa
                </Typography>
                <hr />
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'persons.type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo"
                      source="type"
                      choices={[
                        { id: 'teacher', name: 'Professor' },
                        { id: 'autor', name: 'Autor' },
                        { id: 'involved', name: 'Pessoa Envolvida' },
                      ]}
                      validate={[required('Obrigatório')]}
                      resettable
                      externalLoading={false}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'persons.title'}>
                    <TextInput
                      fullWidth
                      label="Nome"
                      source="title"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'persons.subtitle'}>
                    <TextInput
                      fullWidth
                      label="Subtítulo"
                      source="subtitle"
                      validate={[required('Obrigatório')]}
                      multiline
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography color="primary" gutterBottom>
                    Imagem
                  </Typography>
                  <Tooltip title={'persons.avatar'}>
                    <ImageInput
                      source="files"
                      label="Utilize imagens já otimizadas para web. Formatos PNG e JPG."
                      accept="image/*"
                      placeholder={<p>Clique aqui ou arraste uma imagem</p>}
                    >
                      <ImageField source="src" title="title" />
                    </ImageInput>
                  </Tooltip>
                </Grid>

                <FormDataConsumer>
                  {({ formData, ...rest }) => formData.type === 'teacher' &&
                    <>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <hr />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Tooltip title={'persons.byography'}>
                          <TextInput
                            fullWidth
                            label="Biografia"
                            source="biography"
                            validate={[required('Obrigatório')]}
                            multiline
                          />
                        </Tooltip>
                      </Grid>
                    </>
                  }
                </FormDataConsumer>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
